import { render, staticRenderFns } from "./CursorHoverMailText.vue?vue&type=template&id=37215132&"
import script from "./CursorHoverMailText.vue?vue&type=script&lang=js&"
export * from "./CursorHoverMailText.vue?vue&type=script&lang=js&"
import style0 from "./CursorHoverMailText.vue?vue&type=style&index=0&id=37215132&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports